import * as React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import DynamicForm from "../../../../../../../core/presentations/DynamicForm";
import Validators from "../../../../../../../ui/helpers/validators";
import TopLabelFieldTemplate from "../../../../../../../ui/templates/fields/TopLabelFieldTemplate";
import VerticalFormTemplate from "../../../../../../../ui/templates/objects/VerticalFormTemplate";

const UserAuthentication = (props: any) => {
  const { onError, onSubmit, submitButton } = props;
  const { t } = useTranslation();
  const [formData, setFormData] = useState(null);

  const onChange = (formData: any) => {
    setFormData(formData);
  };

  const schema: any = {
    type: "object",
    properties: {
      userName: {
        type: "string",
        title: t("users.label.userName"),
      },
      password: {
        type: "string",
        title: t("users.label.password"),
      },
    },
    required: ["userName", "password"],
  };

  const validationSchema: any = {
    userName: {
      validators: [
        {
          validate: (value: string) => {
            return !Validators.isStringEmpty(value);
          },
          messageKey: "users.validation.userNameRequired",
        },
      ],
    },
    password: {
      validators: [
        {
          validate: (value: string) => {
            return !Validators.isStringEmpty(value);
          },
          messageKey: "users.validation.passwordRequired",
        },
      ],
    },
  };

  const uiSchema: any = {
    "ui:ObjectFieldTemplate": VerticalFormTemplate,
    userName: {
      "ui:widget": "prwInputText",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12 p-lg-6",
      "ui:emptyValue": "",
    },
    password: {
      "ui:widget": "prwPassword",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12 p-lg-6",
      "ui:emptyValue": "",
      "ui:options": {
        showFeedback: true,
      },
    },
  };

  return (
    <div>
      <DynamicForm
        onChange={onChange}
        formData={formData}
        onSubmit={onSubmit}
        onError={onError}
        schema={schema}
        uiSchema={uiSchema}
        validationSchema={validationSchema}
        formButtons={() => submitButton()}
      ></DynamicForm>
    </div>
  );
};

export default UserAuthentication;
